import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const API_URL = config.backendUrl;

export const fetchLeadByQuotationNumber = createAsyncThunk(
    "quotation/fetchLeadByQuotationNumber",
    async (quotationNumber, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.get(
                `${API_URL}/generatequotation/lead-by-quotation-number/${quotationNumber}`
            );
            return res.data; // { message, leadid }
        } catch (err) {
            return rejectWithValue(
                err.response?.data?.message || "Failed to fetch lead"
            );
        }
    }
);


const getLeadByQuotationNumberSlice = createSlice({
    name: "getLeadByQuotationNumber",
    initialState: {
        loading: false,
        leadid: null,
        error: null,
    },
    reducers: {
        resetLeadByQuotation: (state) => {
            state.loading = false;
            state.leadid = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeadByQuotationNumber.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLeadByQuotationNumber.fulfilled, (state, action) => {
                state.loading = false;
                state.leadid = action.payload.leadid; // ⬅️ just this
            })
            .addCase(fetchLeadByQuotationNumber.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetLeadByQuotation } = getLeadByQuotationNumberSlice.actions;
export default getLeadByQuotationNumberSlice.reducer;
